var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMicrosoftWordLogo = function SvgIconMicrosoftWordLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.132 8.78a1 1 0 0 1 1.213.727l.42 1.683.321-.721a1 1 0 0 1 1.828 0l.32.72.42-1.682a1 1 0 1 1 1.941.486l-1.125 4.5a1 1 0 0 1-1.884.163L9 13.337l-.586 1.32a1 1 0 0 1-1.884-.165l-1.125-4.5a1 1 0 0 1 .727-1.212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 5.375V3.75A1.75 1.75 0 0 1 6.75 2h12a1.75 1.75 0 0 1 1.75 1.75v16.5A1.75 1.75 0 0 1 18.75 22h-12A1.75 1.75 0 0 1 5 20.25v-1.625H3.75A1.75 1.75 0 0 1 2 16.875v-9.75c0-.966.784-1.75 1.75-1.75zm2 0V4h11.5v4H16v-.875a1.75 1.75 0 0 0-1.75-1.75zm0 13.25V20h11.5v-4H16v.875a1.75 1.75 0 0 1-1.75 1.75zM16 14h2.5v-4H16zm-2-6.625H4v9.25h10z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconMicrosoftWordLogo;